import type { FC } from "react";
import React, { memo } from "react";
import clsx from "clsx";
import { useGradeSelectorSelector } from "../../../redux/hooks";
import { selectModel } from "../../../redux/slices/GradeSelectorModelSlice";
import Text from "../../../../shared-components/css-modules/toyota/atoms/Text";
import Item from "./Item";
import styles from "../../../../shared-components/css-modules/toyota/organisms/GradeSwitcher.module.scss";
import { GradeSelectorMemoLabel } from "../../../utils/labels";
import { useFilteredGradeBodyTypes } from "../../../utils/filterHooks";
import Filter from "../selector/actions/filter/Filter";
import ExchangeRate from "../selector/exchange-rate/ExchangeRate";
import { getThemeClassname } from "../../../../../../common-deprecated/utils";
import { getUniqueGradeBodyTypeId } from "../../../../../../common-deprecated/features/apheleia/utils/aphUtils";
import { LcvFilters } from "../lcv-filter/LcvFilters";
import { IntegratedLegalBannerDisclaimer } from "../../../../../shared-components/toyota/IntegratedLegalBannerDisclaimer";
import useDisclaimerContent from "../../../hooks/useDisclaimerContent";

const GradeSwitcher: FC<{
    selectedGradeBodyId?: string;
    onSelect?: (
        carId: string,
        name: string,
        selectedColourId: string,
        selectedColourCode: string,
        carExtras: string[],
    ) => void;
    onKeep?: () => void;
}> = ({ selectedGradeBodyId, onSelect, onKeep }) => {
    const { name, id } = useGradeSelectorSelector(selectModel);
    const hasLcvFilters = useGradeSelectorSelector(
        (state) => state.gradeSelectorLcvFilters.initialized && state.gradeSelectorLcvFilters.filters.length > 0,
    );
    const gradeBodyTypes = useFilteredGradeBodyTypes();
    const disclaimerData = useDisclaimerContent();

    return (
        <div className={clsx(styles.wrapper, getThemeClassname(id))}>
            <div className={styles.header}>
                <Text variant="apheleia-h3" tag="h2">
                    <GradeSelectorMemoLabel label="gradeSelectorGradeSwitcherTitle" params={{ model: name }} />
                </Text>
            </div>
            <div className={styles.filters}>{!hasLcvFilters ? <Filter /> : <LcvFilters />}</div>
            <div className={styles.scroll}>
                <div className={styles.grid}>
                    {gradeBodyTypes.map((gradeBodyType, nKey) => {
                        const key = getUniqueGradeBodyTypeId(
                            gradeBodyType.grade.id,
                            gradeBodyType.bodyType.id,
                            gradeBodyType.submodel?.id,
                        );
                        return (
                            <div
                                className={styles.item}
                                key={key}
                                style={{ "--or-motorization-z-index": (gradeBodyTypes.length - nKey) * 100 }}
                            >
                                <Item
                                    gradeBodyType={gradeBodyType}
                                    isSelected={selectedGradeBodyId === key}
                                    onSelect={onSelect}
                                    onKeep={onKeep}
                                />
                            </div>
                        );
                    })}
                </div>
                <IntegratedLegalBannerDisclaimer data={disclaimerData} />
            </div>

            <ExchangeRate />
        </div>
    );
};

export default memo(GradeSwitcher);
